import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Define prop types for our component
interface MarkdownRendererProps {
  markdown: string;
  className?: string;
}

/**
 * A unified markdown renderer component using react-markdown
 * This component can be used throughout the app for consistent markdown rendering
 */
const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  markdown,
  className = "markdown-content"
}) => {
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]} // Support GFM (tables, strikethrough, etc.)
        components={{
          // Make all links open in a new tab
          a: ({node, ...props}) => <a target="_blank" rel="noopener noreferrer" {...props} />,

          // Apply custom classes to tables
          table: ({node, ...props}) => (
            <div className="table-container">
              <table className="markdown-table" {...props} />
            </div>
          ),

          // Custom code block rendering
          code: ({node, inline, className, children, ...props}) => {
            return inline ? (
              <code className="inline-code" {...props}>{children}</code>
            ) : (
              <pre className="code-block">
                <code className={className} {...props}>{children}</code>
              </pre>
            );
          }
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
